<modal-popup
  [flexible]="true"
  [focusOnOpen]="true"
  [isOpen]="true"
  (onClose)="close()"
  [title]="'translate.rev.pageToolTitle' | translate"
  [afterTitle]="save"
>
    <div class="container page-tool-container">

        <div class="l-align-spaceBetween page-tool-manage-option">
            <a (click)="showManagePhrases = true" class="add-link">
                <i class="fas fa-plus"></i>
                &nbsp;
                {{ 'translate.rev.pageToolManagePhrases' | translate }}
            </a>
            <a *ngIf="showManagePhrases" (click)="showManagePhrases = false" class="t-small">
            {{ "translate.general.close" | translate }}
            </a>
        </div>

        <div *ngIf="showManagePhrases">
            <p-table
            [value]="phrases"
            [loading]="loading"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{ 'translate.rev.pageToolRevealPhrase' | translate }}</th>
                        <th>{{ 'translate.general.phraseId' | translate }}</th>
                        <th>{{ 'translate.general.phraseText' | translate }}</th>
                        <th>{{ 'translate.general.contentType' | translate }}</th>
                    </tr>
                </ng-template>
                

                <ng-template pTemplate="body" let-phrase let-rowIndex="rowIndex">
                    <tr>
                        <td>
                            <input type="checkbox" [checked]="selectedPhrases.indexOf(phrase.phrase_id) !== -1" (change)="onPhraseSelected($event.target.checked, phrase)" />
                        </td>
                        <td>{{ phrase.phrase_id }}</td>
                        <td>{{ phrase.phrase_text }}</td>
                        <td>{{ phrase.phrase_content_type }}</td>
                    </tr>
                </ng-template>

            </p-table>

            <div style="margin-top: 2rem;">
                <span>{{ 'translate.general.contentTypeDescr' | translate }}: </span><a [class.disabled]="loading ? true : null" (click)="overlay.toggle($event);">{{ selectedContentType.label }}</a>
                <p-popover #overlay [dismissable]="true" appendTo="body" baseZIndex="999999">
                    <ul class="menu-list">
                        <li 
                            *ngFor="let item of contentTypes" 
                            (click)="selectContentType(item); overlay.toggle($event);"
                            [ngClass]="{ 'selected': item.id === selectedContentType?.id }"
                        >
                            {{ item.label }}
                        </li>
                    </ul>
                </p-popover>
            </div>
        </div>

        <div class="l-align-spaceBetween page-tool-manage-option">
            <a (click)="showManageImages = true" class="add-link">
                <i class="fas fa-plus"></i>
                &nbsp;
                {{ 'translate.rev.pageToolManageImages' | translate }}
            </a>
            <a *ngIf="showManageImages" (click)="showManageImages = false" class="t-small">
            {{ "translate.general.close" | translate }}
            </a>
        </div>

        <div *ngIf="showManageImages">
            <p-table
            [value]="images"
            [loading]="loading"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{ 'translate.rev.pageToolRevealPhrase' | translate }}</th>
                        <th>{{ 'translate.general.imageId' | translate }}</th>
                        <th>{{ 'translate.general.image' | translate }}</th>
                        <th>{{ 'translate.general.figureTypeDescr' | translate }}</th>
                    </tr>
                </ng-template>
                

                <ng-template pTemplate="body" let-image let-rowIndex="rowIndex">
                    <tr>
                        <td>
                            <input type="checkbox" [checked]="selectedImages.indexOf(image.image_id) !== -1" (change)="onImageSelected($event.target.checked, image)" />
                        </td>
                        <td>{{ image.image_id }}</td>
                        <td><async-img [className]="'ind-img'" [url]="image.imgUrl"></async-img></td>
                        <td>{{ image.figure_type }}</td>
                    </tr>
                </ng-template>

            </p-table>
        </div>

        <loader *ngIf="loading"></loader>
    </div>
</modal-popup>

<ng-template #phraseText let-row="row">
    {{ row.phrase_text }}
</ng-template>

<ng-template #save>
    <div>
        <p>
            <button [disabled]="loading || (selectedPhrases.length === 0 && selectedImages.length === 0)" class="t-button t-button-warn" icon="pi pi-save" (click)="saveChanges()">
                {{ "translate.general.saveChanges" | translate }}
            </button>
        </p>
    </div>
</ng-template>
